<template>
  <div class="table-cell">
    {{ $tc(`checkout.${feature.feature_name}`, feature.plus ) }}

    <template v-if="feature.feature_name === 'room_earnings'">
      <div v-tippy="{ trigger: 'mouseenter focus' }" class="tooltip" :content="$t('checkout.earn_tooltip')" />
    </template>
  </div>
</template>
<script>
export default {
  name: "FeatureCell",
  props: {
    feature: {
      type: Object,
      required: true,
    }
  }
};
</script>

<style lang="scss">
.table-cell {
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  vertical-align: middle;
  border-top: 1px solid #e0e0e0;
  .tooltip {
    display: block;
    width: 15px;
    height: 15px;
    margin-left: 10px;
    background-image: url(~@/assets/images/icons/icon-info-grey.svg);
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: left center;
    transition: all ease .2s;
  }
}

@media screen and (max-width: 768px) {
  .table-cell {
    .tooltip {
      display: none;
    }
  }
}
</style>
